import { MouseEventHandler } from "react";

import AddUserPng from "./add_user_icon.png";

type AddUserIconProps = {
  onClick: MouseEventHandler<HTMLImageElement>;
  width?: number;
};

export const AddUserIcon = ({ width, onClick }: AddUserIconProps) => (
  <img
    src={AddUserPng}
    alt="add"
    onClick={onClick}
    style={{ cursor: "pointer", height: "auto" }}
    width={width}
  />
);
